<div [hidden]="fileSrc != null">
  <div class="main">
    <div class="image" [style.height]="imageHeight + 'px'">
      @if (partner) {
      <partner-avatar
        [partner]="partner"
        [width]="255"
        [height]="imageHeight"
        [alt]="partner.name"
      ></partner-avatar>
      } @else {
      <file-jet-img
        [image]="image"
        [width]="255"
        [height]="imageHeight"
        [alt]="placeholder"
      ></file-jet-img>
      }
    </div>

    <div>
      <div class="controls">
        <div #fineUploader></div>

        @if (image) {
        <a (click)="removeImage()" class="remove">
          <icon type="x"></icon>
          Remove image
        </a>
        }
      </div>
    </div>
  </div>
</div>

@if (fileSrc != null) {
<div class="cropper">
  <div class="img-wrapper"><img #cropper [src]="fileSrc" /></div>
  <div class="controls">
    <btn (click)="crop()" icon="check2">Crop</btn>
    &nbsp;or&nbsp;
    <a (click)="cancel()">cancel</a>
  </div>
</div>
}

<div id="qq-image-uploader" style="display: none">
  <div class="qq-uploader-selector">
    <div class="btn btn-default qq-upload-button-selector">
      <div>
        <icon type="upload"></icon>
        Upload new image
      </div>
    </div>
    <ul style="display: none" class="qq-upload-list-selector qq-upload-list">
      <li></li>
    </ul>

    <dialog class="qq-alert-dialog-selector">
      <div class="qq-dialog-message-selector"></div>
      <div class="qq-dialog-buttons">
        <button type="button" class="qq-cancel-button-selector">Close</button>
      </div>
    </dialog>
  </div>
</div>
